module.exports = __webpack_public_path__ + "static/media/1.fc769271.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/80192/1.jpg
// module id = 758
// module chunks = 0